
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/repair-pricing/home-buyers",
      function () {
        return require("private-next-pages/repair-pricing/home-buyers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/repair-pricing/home-buyers"])
      });
    }
  